var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock13X16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 6.5H3C1.89543 6.5 1 7.39543 1 8.5V13C1 14.1046 1.89543 15 3 15H10C11.1046 15 12 14.1046 12 13V8.5C12 7.39543 11.1046 6.5 10 6.5Z",
    stroke: "#B8B8BC",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.6 6.5V4.4C3.6 3.63087 3.90553 2.89325 4.44939 2.34939C4.99325 1.80553 5.73087 1.5 6.5 1.5C7.26913 1.5 8.00675 1.80553 8.55061 2.34939C9.09447 2.89325 9.4 3.63087 9.4 4.4V6.5",
    stroke: "#B8B8BC",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock13X16);
export default __webpack_public_path__ + "static/media/lock-13x16.1b01a3604adab75375de8b89a69871c3.svg";
export { ForwardRef as ReactComponent };